export const TEXTS = {
  CREATE_POINTS_GROUP: 'Создать группу',
  PAGE_TITLE: 'Адреса',
  DOC_TITLE: 'Группы адресов – Звук Бизнес',
  TEXT_POINTS_SEARCH_EMPTY: 'Мы не нашли групп адресов по такому запросу',
  TEXT_POINTS_GROUPS_EMPTY: 'Создайте свою первую группу адресов',
  POINTS_LIST_EMPTY: 'У вас нет адресов',
  SEARCH: 'Поиск по адресам',
  MODAL_SELECT_POINTS_BUTTON_SUBMIT_TEXT: 'Сохранить',
  NEXT: 'Далее',
  CANCEL: 'Отменить',
  MODAL_SELECT_POINTS_TITLE: 'Выбор адресов',
  MODAL_SELECT_MASTER_VIDEO_STREAM_TITLE: 'Выбор мастер-видеоволны',
  MODAL_SELECT_MASTER_VIDEO_STREAM_DESCRIPTION:
    'Все видеоволны в группе будут подстроены по длительности под выбранную мастер-видеоволну',
  SELECT_POINTS_SUCCESS: 'Адреса успешно изменены',
  SELECT_MASTER_VIDEO_STREAM_SUCCESS: 'Мастер-видеоволна успешно изменена',
  CREATE_GROUP_SUCCESS: 'Группа адресов успешно создана',
  BACK: 'Назад',
};
